export default __webpack_public_path__ + "static/media/MD.2abea696.svg";